import { IResourceComponentsProps, useExport, useList, useShow } from '@pankod/refine-core'

import {
  List,
  RefreshButton,
  CreateButton,
  ExportButton,
  Table,
  Space,
  EditButton,
  DeleteButton,
  DateField,
  getDefaultSortOrder,
  useModalForm,
  Icons,
  Tag,
  Input,
  Divider,
  Button,
  useTable,
  Form
} from '@pankod/refine-antd'
import CreateConfig from './create'
import { IConfiguration } from 'interfaces'
const { PlusOutlined } = Icons

const ListConfigurations=()=>{
    const { formProps, modalProps, show } = useModalForm({
        resource: 'configurations',
        action: 'create',
      })
    const { sorter, tableQueryResult,setFilters ,tableProps,searchFormProps} = useTable<IConfiguration>({
        // hasPagination:pagination,
        initialSorter: [
          {
            field: 'created_at',
            order: 'desc',
          },
        ],
        metaData:{
            fields:[
                'id',
                'user_types',
                'period_days',
                'created_at',
                'updated_at',
                'created_by',
                'updated_by',
                {creatorDetails:['displayName']},
                {updatedByDetails:['displayName']},
                
            ]
        },
        onSearch: (values:any) => {
          return [
              {
                  field: "name",
                  operator: "contains",
                  value:`%${values.title}%`,
              },
          ];
      },
      })
    return(
        <List
        pageHeaderProps={{
          extra: [
            //  <ExportButton onClick={triggerExport} loading={isLoading} />,
            // <RefreshButton onClick={() => tableQueryResult?.refetch()} />,
            <CreateButton type="primary" icon={<PlusOutlined />} onClick={() => show()} />,
            
          ],
        }}
      >
                 {/* <Form {...searchFormProps}>
          <Space>
              <Form.Item name="title">
                  <Input placeholder="Search by title" allowClear  onChange={(e)=>{
                              if(e.type==='click'){
                                searchFormProps.form?.submit()
                              }}}/>
              </Form.Item>
              <Button icon={<Icons.SearchOutlined/>} onClick={searchFormProps.form?.submit} >Search</Button>
          </Space>
      </Form> */}
      <Divider/>
        <Table {...tableProps}
         >
          <Table.Column dataIndex="period_days" title="Period Days" />
          <Table.Column<IConfiguration> dataIndex="user_types" title="User Types" 
           render={(_, record) => 
       record?.user_types?.map((item:any)=>
    
        <Tag color={'geekblue'} key={item}>
          {item.toUpperCase()}
        </Tag>
  
       )
        
        }
          
   
 />
          {/* <Table.Column<IGrade>
              dataIndex="medium_id"
              title="Medium"
              render={(_, record) => record?.medium?.name}
            /> */}
  
          {/* <Table.Column<IDifficultyLevel> dataIndex="order" title="Order" /> */}
  
          <Table.Column
            dataIndex="created_at"
            title="Created At"
            render={value => <DateField value={value} format="LLL" />}
            defaultSortOrder={getDefaultSortOrder('created_at', sorter)}
            sorter
          />
          {/* <Table.Column<IDifficultyLevel>
            title="Actions"
            dataIndex="actions"
            render={(_, record) => (
              <Space>
                <EditButton
                  size="small"
                  type="link"
                  icon={null}
                  recordItemId={record.id}
                  onClick={() => {
                    setShowId(record?.id)
                    editShow(record.id)
                  }}
                />
                <DeleteButton
                  size="small"
                  type="link"
                  icon={null}
                  recordItemId={record.id}
                  //   hidden={hideDeleteButton(record)}
                />
              </Space>
            )}
          /> */}
        </Table>
        <CreateConfig modalProps={modalProps} formProps={formProps} />
        {/* // <EditDifficultyLevel modalProps={editModalProps} formProps={editFormProps} record={record} />  */}
      </List>
    )
}
export default ListConfigurations